import { Leaf } from "lucide-react";

// Shared frame for the lock and set-up screens.
export default function LockShell({ title, subtitle, children }) {
  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center px-6 nest-safe-y">
      <div className="w-12 h-12 rounded-2xl nest-brand-fill text-white shadow-lg shadow-nest-brand/30 flex items-center justify-center mb-5">
        <Leaf size={22} strokeWidth={1.5} />
      </div>
      <h1 className="font-heading text-2xl font-medium text-center">{title}</h1>
      {subtitle && (
        <p className="text-sm text-nest-muted text-center mt-2 max-w-xs">{subtitle}</p>
      )}
      <div className="mt-8 w-full flex flex-col items-center">{children}</div>
    </div>
  );
}

export function faceIdErrorMessage(err) {
  if (err?.message === "PRF_UNSUPPORTED") {
    return "This device can't use Face ID with Nest (it needs iOS 18 or newer). Your PIN still works.";
  }
  if (err?.name === "NotAllowedError") return "Face ID was cancelled.";
  return "Face ID didn't work. Use your PIN instead.";
}
